<template>
  <div class="axj-within-school">
    <work-header
      @create="handleCreate"
    />
    <work-main
          :data="tableData"
          @update="handleUpdate"
          @editBusiness="business.show=true"
          :company="company"
          @editDirect="handleEditDirect"
          @showCurriculumVitae="handleShowCurriculumVitae"
          @create-work="handleCreateWork"
          @deleteWork="handleDeleteWork"
          :len="curriculumVitae.data.length"
    />
    <work-footer
          :page-data="page"
          @page-change="handlePaginationChange"
    />
    <business
      @editSuccess="handleBusinessEditSuccess"
      :show.sync="business.show"/>
    <direct-edit
      :company_id="direct.company_id"
      :show.sync="direct.show"
    />
    <curriculum-vitae
      :show.sync="curriculumVitae.show"
      @showBiographicalNotes="handleShowBiographical"
      :data="curriculumVitae.data"
    />
    <work-edit
      @editSuccess="handleEditSuccess"
      :is-create="work.isCreate"
      :show.sync="work.show"
      :id="work.id"
    />
    <biographical-notes
      :userId="biographicalNotes.user_id"
      :show.sync="biographicalNotes.show"
      :checkedRow="checkedRow"
      :createTime='biographicalNotes.createTime'
      :mark_id="biographicalNotes.mark_id"
      :offerdeliverersId="biographicalNotes.offerdeliverersId"
      :index='biographicalNotes.index'
      @next='handleNext'
      @last='handleLast'
      @marked="handleShowCurriculumVitae(lastQuery.v,lastQuery.isDirect,lastQuery.workId,lastQuery.row)"
    />
  </div>
</template>

<script>
import WorkHeader from "./component/work-header/index";
import WorkMain from "./component/work-main/index";
import WorkFooter from "./component/work-footer/index";
import {deleteServiceWorkOffer,fetchServiceWorkOfferList,GetServiceWorkOfferDelivererRelations,fetchServiceWorkCompanyList} from "../../../api/axj-service/axj-service-work"
import Business from "./component/business/index";
import DirectEdit from "./component/direct-edit/index";
import CurriculumVitae from "./component/curriculum-vitae/index";
import BiographicalNotes from "./component/biographical-notes/index"
import WorkEdit from "./component/work-edit/index";

export default {
  name: "axj-work",
  components: {WorkEdit, CurriculumVitae, DirectEdit, Business, WorkFooter, WorkMain, WorkHeader,BiographicalNotes},
  created() {
    this.initData()
    this.initCompany()
    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
    
  },
  data(){
    return {
      work:{
        show:false,
        id:undefined,
        isCreate:false
      },
      checkedRow:{

      },
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      curriculumVitae:{
        show:false,
        data:[]
      },
      withInEdit:{
        create:true,
        show:false,
        withInId:undefined
      },
      business:{
        show:false
      },
      company:undefined,
      direct:{
        show:false,
        company_id:0
      },
      biographicalNotes:{
        show:false,
        user_id:undefined,
        createTime:undefined,
        index:0,
        mark_id:undefined,
        offerdeliverersId:undefined
      },
      lastQuery:{

      }
    }
  },
  methods:{
    handleLast(index){
      console.log(index)
     
    if(index-1!=-1){
        this.handleShowBiographical(this.curriculumVitae.data[index-1].user_id,this.curriculumVitae.data[index-1].created_at,index-1)
      }else{
         this.$message({
        message:'翻到头了哦！'
      })
      }
    },
    handleNext(index){
      //2
      //1
      if(this.curriculumVitae.data.length>index+1){
        this.handleShowBiographical(this.curriculumVitae.data[index+1].user_id,this.curriculumVitae.data[index+1].created_at,index+1)
      }else{
         this.$message({
        message:'翻到底了哦！'
      })
      }
    },
    handleShowBiographical(id,createTime,index,mark_id,offerdeliverersId){
      this.biographicalNotes.user_id=id
      this.biographicalNotes.show=true
      this.biographicalNotes.createTime=createTime
      this.biographicalNotes.index=index
      this.biographicalNotes.mark_id=mark_id
      this.biographicalNotes.offerdeliverersId=offerdeliverersId
    },
    handleEditSuccess(){
      this.initData()
    },
    handleDeleteWork(id){
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteServiceWorkOffer(id)
        this.initData()
      })

    },
    handleCreateWork(){
      this.work.id=this.company.id
      this.work.isCreate=true
      this.work.show=true
    },
    handleShowCurriculumVitae(v,isDirect,workId,row){
      this.listCurriculumVitae(isDirect?1:0,workId)
      this.curriculumVitae.show=true
      this.checkedRow.checkedRow=row
      this.lastQuery.v=v
      this.lastQuery.isDirect=isDirect
      this.lastQuery.workId=workId
      this.lastQuery.row=row
    },
    listCurriculumVitae(type,id){
      return new Promise((resolve,reject)=>{
        GetServiceWorkOfferDelivererRelations({
          preload:true,
          where:JSON.stringify({
            company_id:this.company.id,
            type:type,
            offer_id:id
          })
        }).then(res=>{
          this.curriculumVitae.data=res.data.lists
          resolve(res)
        },error => {
          reject(error)
        })
      })
    },
    handleEditDirect(v){
      this.direct.company_id=v
      this.direct.show=true
    },
    initCompany(){
      let id= this.$store.getters.getUser.info.ServiceWorkUser.id
      fetchServiceWorkCompanyList({
        where:JSON.stringify({
          user_id:id
        })
      })
        .then(res=> {
          this.company=res.data.lists[0]
          this.listCurriculumVitae(1)
        })
    },
    handleBusinessEditSuccess(){
      this.initCompany()
      this.business.show=false
    },
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    },
    handleClubClose(){
      this.withInEdit.show=false
    },
    handleCreate(){

      this.withInEdit.create=true
      this.withInEdit.show=true
    },
    initData(){

      let user=this.$store.getters.getUser
      fetchServiceWorkOfferList({
        ...this.page,
        preload:true,
        where:JSON.stringify({
          user_id:user.info.ServiceWorkUser.id
        })
      }).then(res=>{
        this.tableData=res.data.lists
        this.page.pageTotal=res.data.total
      },error=>{
      })
    },
    handleUpdate(id){
      this.withInEdit.withInId=id
      this.withInEdit.create=false
      this.withInEdit.show=true
    },
    handleUpdated(){
      this.withInEdit.show=false
      this.initData()
    },
    handleCreated(){
      this.withInEdit.show=false
      this.initData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/index.vue